import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'workflow-composer',
});

export const workflowDetailRouteRef = createSubRouteRef({
  id: 'workflow-composer/detail',
  parent: rootRouteRef,
  path: '/:workflowId',
});
